<template>
  <div class="side-nav globa__side-nav">
    <div class="logo">
      <svg-icon icon-class="rii" />
    </div>
    <div class="menu">
      <el-menu
        :default-active="$route.path"
        class="side-menu"
        :collapse="isCollapse"
        :default-openeds="defaultOpeneds"
        @select="handleSelect"
        router
      >
        <component
          v-for="(menu, index) in NavbarConfigs"
          :key="'sidebar-menu-' + index"
          :is="menu.type === 'group' ? 'el-submenu' : 'el-menu-item'"
          :index="menu.index"
          :class="{
            'sideNav-active': menu.index === activeMenu,
            'not-menu-group': menu.type !== 'group'
          }"
        >
          <template slot="title" v-if="menu.type === 'group'">
            <div
              class="menu-title"
              @click.stop.prevent="clickMenuGroup(menu.index)"
            >
              <div class="menu-title-icon-wrapper">
                <svg-icon :icon-class="menu.icon" />
              </div>
              <span class="text"> {{ menu.text }} </span>
            </div>
          </template>
          <div class="menu-title" v-else>
            <div class="menu-title-icon-wrapper">
              <svg-icon :icon-class="menu.icon" />
            </div>
            <span class="text"> {{ menu.text }} </span>
          </div>
          <el-menu-item
            v-for="(subMenu, innerIndex) in menu.subs"
            :key="'inner-menu-' + innerIndex"
            :index="menu.index + '/' + subMenu.index"
          >
            <div class="submenu-title">
              <span>{{ subMenu.text }}</span>
            </div>
          </el-menu-item>
        </component>
      </el-menu>
    </div>
  </div>
</template>
<script>
import { NavbarConfigs } from '@/router/index'
import SideNavMessage from '@/core/message/sidenav'
import SvgIcon from '@/components/common/SvgIcon.vue'
export default {
  name: 'NavMenu',
  components: { SvgIcon },
  data() {
    return {
      NavbarConfigs,
      isCollapse: false,
      activeMenuGroup: ''
    }
  },
  mounted() {
    SideNavMessage.on(
      SideNavMessage.eventMap.OPEN_CLOSE_SIDE_MENU,
      this.toggleMenu
    )
  },
  beforeDestroy() {
    SideNavMessage.off(
      SideNavMessage.eventMap.OPEN_CLOSE_SIDE_MENU,
      this.toggleMenu
    )
  },
  computed: {
    defaultOpeneds() {
      return NavbarConfigs.map(item => item.index)
    },
    activeMenu() {
      const paths = this.$route.path.split('/')
      return '/' + paths[1]
    }
  },
  methods: {
    toggleMenu() {
      this.isCollapse = !this.isCollapse
    },
    handleSelect(key, keyPath) {
      if (this.$route.path !== key) {
        this.$router.push(key).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error
          }
        })
      }
    },
    clickMenuGroup(path) {
      this.$router.push({ path }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/styles/var.scss';
$menu-item-cover-radius: 8px;

.side-menu .el-menu-item,
.side-menu .el-submenu .el-submenu__title {
  height: $home-nav-menu-item-height;
  padding: 0;
  padding-left: 18px !important;
  margin-right: 10px;
  border-top-right-radius: $menu-item-cover-radius;
  border-bottom-right-radius: $menu-item-cover-radius;
}

.el-menu-item.not-menu-group {
  color: black !important;
}

.side-menu .el-menu-item.sideNav-active {
  background-color: $business-color !important;

  .menu-title {
    span {
      color: white;
    }

    svg {
      filter: $svg-color-white;
    }
  }
}

.side-menu .el-submenu {
  .el-menu.el-menu--inline {
    li {
      height: 36px !important;
      min-width: 100%;
    }
  }

  .el-menu.el-menu--inline .el-menu-item {
    padding: 0 !important;
    color: #625b5b;

    &:focus,
    &:active,
    &:hover {
      background-color: white !important;
    }

    &.is-active {
      color: #1732cb !important;
    }
  }

  .el-submenu__icon-arrow {
    font-size: 14px;
    font-weight: 600;
    padding: 10px;
    margin-top: -17px !important;
    right: 0 !important;
  }

  &.sideNav-active {
    .el-submenu__title {
      background-color: $business-color !important;

      .menu-title {
        span {
          color: white;
        }

        svg {
          color: black !important;
          filter: $svg-color-white;
        }
      }
    }

    .el-submenu__icon-arrow {
      color: white;
    }
  }
}
</style>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';
$menu-item-cover-radius: 8px;

.side-nav {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #ada9a9;
  }

  @extend .shadow-level-one;

  .logo {
    text-align: center;
    padding: 5px 0;
    padding-top: 10px;

    .svg-icon {
      height: 42px;
      width: 42px;
      border-radius: 4px;
    }

    @extend .f-r-c-c;
  }
}

.side-menu {
  border: none;

  &:not(.el-menu--collapse) {
    width: $side-menu-width-expand;
  }

  .submenu-title {
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 600;
    padding-left: 40px;
    margin-right: 10px;
    border-top-right-radius: $menu-item-cover-radius;
    border-bottom-right-radius: $menu-item-cover-radius;
    line-height: 36px;
    height: 36px;

    &:focus,
    &:active,
    &:hover {
      background-color: rgba(#1732cb, 0.1) !important;
    }
  }

  .menu-title {
    display: flex;
    align-items: center;
    height: $home-nav-menu-item-height;

    .menu-title-icon-wrapper {
      display: flex;
      align-items: center;
      height: 100%;

      .svg-icon {
        width: 28px;
        height: 28px;
      }
    }

    .text {
      font-size: 18px;
      font-family: 'oswald bold', sans-serif;
      font-weight: bold;
      margin-left: 10px;
    }
  }
}
</style>
